// extracted by mini-css-extract-plugin
export var codes = "verify-module--codes--e8fdf";
export var confirm = "verify-module--confirm--9980e";
export var confirmSubtitle = "verify-module--confirmSubtitle--1787b";
export var copy = "verify-module--copy--c3f61";
export var error = "verify-module--error--26145";
export var verifyButton = "verify-module--verifyButton--6078d";